import React from "react";

export default function StatCard({ data }) {
  return (
    <div
      style={{ background: data.bg }}
      className={`rounded-[20px] px-[21px] py-[23px] shadow-[0_3px_4px_0_#00000040] `}
    >
      <div className="w-12 sm:w-16 h-12 sm:h-[51px] bg-white rounded-[7px] flex items-center justify-center mb-4 sm:mb-6">
        <img
          src={data.icon}
          alt="card icon "
          className="w-5 h-5 sm:w-auto sm:h-auto"
        />
      </div>

      <div className="text-lg sm:text-xl leading-4 sm:leading-6 text-[#878686]">
        {data.label}
      </div>
      <div className="mt-3 text-[32px] sm:text-4xl leading-4 sm:leading-6 font-bold text-black ">
        {data.value}
      </div>
    </div>
  );
}
